import React from 'react';
import { Link } from 'react-router-dom';

const Footer: React.FC = () => {
  return (
    <div className="container-fluid bg-dark text-white-50 footer mt-5 pt-5" data-aos="fade" data-aos-delay="100">
      <div className="container py-5">
        <div className="row g-5">
          <div className="col-lg-4 col-md-6">
            <h4 className="fw-bold text-primary mb-4">
              Humanity<span className="text-white">Trust</span>
            </h4>
            <p>
              Together, we make a difference. Every contribution helps us reach more people in need and create lasting positive change in communities around the world.
            </p>
            <div className="d-flex pt-2">
              <a className="btn btn-square me-1" href="https://www.youtube.com/@thehumanitytrust" target="_blank" rel="noopener noreferrer">
                <i className="fab fa-youtube"></i>
              </a>
              <a
                className="btn btn-square me-1"
                href="https://www.instagram.com/1humanitytrust/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fab fa-instagram"></i>
              </a>
              <a className="btn btn-square me-0" href="https://www.linkedin.com/company/the-humanity-trust/" target="_blank" rel="noopener noreferrer">
                <i className="fab fa-linkedin-in"></i>
              </a>
            </div>
          </div>
          <div className="col-lg-4 col-md-6">
            <h5 className="text-light mb-4">Address</h5>
            <p><i className="fa fa-map-marker-alt me-3"></i>Plot 45, APMC Market Kamalnagar Dist. Bidar Karnataka 585417</p>
            <p><i className="fa fa-phone-alt me-3"></i>+91 9739431427</p>
            <p><i className="fa fa-envelope me-3"></i>info@thehumanitytrust.in</p>
          </div>
          <div className="col-lg-4 col-md-6">
            <h5 className="text-light mb-4">Quick Links</h5>
            <Link to="/about" className="btn btn-link">About Us</Link>
            <Link to="/contact" className="btn btn-link">Contact Us</Link>
            <Link to="/causes" className="btn btn-link">Our Services</Link>
            <Link to="/events" className="btn btn-link">Events</Link>
            <Link to="/terms" className="btn btn-link">Terms & Conditions</Link>
            <Link to="/refund-policy" className="btn btn-link">Refund Policy</Link>
            <Link to="/contact-info" className="btn btn-link">Contact Info</Link>
          </div>
        </div>
      </div>
      <div className="container-fluid copyright">
        <div className="container">
          <div className="row">
            <div className="col-md-6 text-center text-md-start mb-3 mb-md-0">
              &copy; <span>Humanity Trust</span>, All Right Reserved.
            </div>
            <div className="col-md-6 text-center text-md-end"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;

